export default __webpack_public_path__ + "static/media/team.9c3d3974.png";